import { z } from 'zod';

export const schemaForm = z.object({
  email: z.string().email(),
});
